import { render, staticRenderFns } from "./BannerThreeColumn.vue?vue&type=template&id=623130bd&"
import script from "./BannerThreeColumn.vue?vue&type=script&lang=js&"
export * from "./BannerThreeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports